var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9762 23.3185L47.063 19.3716C46.3907 19.068 46.3907 18.1137 47.063 17.8101L55.8244 13.9933C57.9497 13.0608 59.6195 11.3909 60.5521 9.26561L64.3689 0.504214C64.6725 -0.168071 65.6267 -0.168071 65.9303 0.504214L69.7472 9.26561C70.6797 11.3909 72.3496 13.0608 74.4749 13.9933L83.2363 17.8101C83.9085 18.1137 83.9085 19.068 83.2363 19.3716L74.4749 23.1884C72.3496 24.1209 70.6797 25.7908 69.7472 27.9161L65.9303 36.6558C65.6267 37.3498 64.6725 37.3281 64.3689 36.6558L60.6822 28.0679C59.7713 25.9426 58.0798 24.2511 55.9762 23.3185ZM27.2384 82.2195L21.5782 69.0774L21.6216 69.0991C20.2119 65.8678 17.6529 63.2654 14.4216 61.8341L0.780718 55.8052C-0.260239 55.3498 -0.260239 53.8751 0.780718 53.4196L14.183 47.5643C17.4144 46.1546 19.9951 43.5739 21.4047 40.3426L27.2384 26.962C27.6938 25.921 29.1685 25.921 29.6239 26.962L35.4576 40.3426C36.8672 43.5739 39.448 46.1546 42.6793 47.5643L56.0599 53.398C57.1009 53.8534 57.1009 55.3281 56.0599 55.7835L42.6793 61.6172C39.448 63.0268 36.8672 65.6075 35.4576 68.8388L29.6239 82.2195C29.1685 83.2604 27.6938 83.2604 27.2384 82.2195Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.5bf79bf2f781c5192dc756e3d82a0621.svg";
export { ForwardRef as ReactComponent };